import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01f33895&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/scss/common.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./index.scss?vue&type=style&index=1&id=01f33895&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f33895",
  null
  
)

export default component.exports